import React from "react";

import { signOutStartAsync } from "../../redux/user/userActions";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function LogoutModal({ modalOpen, handleClose, ...props }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Dialog open={modalOpen} onOpenChange={handleClose} {...props}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold">
            {t("dashboard.general.logout")}
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to logout?
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="flex gap-2">
          <Button
            variant="default"
            onClick={() => {
              dispatch(signOutStartAsync(navigate));
              handleClose();
            }}
          >
            {t("extra.yes")}
          </Button>
          <Button variant="outline" onClick={handleClose}>
            {t("extra.no")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
